import React from 'react'

function ConsoleButton({ label, onClick }) {
  return (
    <button onClick={onClick}>{label}</button>
  )
}

export default ConsoleButton